
import Mapbox from 'mapbox-gl';
import Location from "@/gis/Location";

class ProxiedGeolocateControl extends Mapbox.GeolocateControl {
  constructor(options) {
    const { proxy, ...rest } = options
    super(rest)
    this._proxy = proxy
  }

  _onSuccess(position) {
    // convert position first
    const { coords } = position
    // call original function
    const loc = new Location(coords.latitude, coords.longitude, coords.altitude)
    const convertedCoords = this._proxy.toWorldLocation(loc)
    super._onSuccess({ 
      ...position, 
      coords: { 
        ...convertedCoords, 
        altitude: convertedCoords.elevation 
      } 
    })
  }

}

export default ProxiedGeolocateControl;
